import { IGroup } from '~/interfaces/groupInterfaces'
import { GroupType } from '~/enums/groupType'

export default class GroupDefinition {
  static isAppGroup(group: IGroup) {
    return group.group_type === GroupType.Application
  }

  static isOrgGroup(group: IGroup) {
    return group.group_type === GroupType.Organization
  }
}

